// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"caa5528d","138":"c37b778d","150":"36506fe0","365":"bc471b66","525":"628b23b5","537":"ea5cef04","588":"7a0a04f8","787":"09d92e0f","795":"37a40d56","825":"f1f1e4b7","834":"21255132","950":"29ccee1d"}[chunkId] + ".chunk.js";
};